import React from "react";
import InstituteFeesView from "@/pages/public/_shared/InstituteFeesView";
import { usePoly } from "./PolyLayout";

export default function PolyFees() {
  const data = usePoly() || {};
  const instId = data?.institute?.id || "";
  return (
    <div data-testid="poly-fees">
      <div className="bg-gradient-to-r from-blue-900 via-blue-800 to-indigo-900 text-white">
        <div className="max-w-6xl mx-auto px-5 py-10">
          <div className="text-[10px] uppercase tracking-[0.3em] font-bold text-amber-400">Know Your Fees</div>
          <h1 className="font-serif text-3xl sm:text-4xl mt-2">Fee Structure</h1>
          <p className="mt-2 text-white/80 text-sm max-w-2xl">Transparent, category-wise fee tables. Data is published and maintained by the Trust admin office.</p>
        </div>
      </div>
      <InstituteFeesView instituteId={instId} testidPrefix="poly-fees" />
    </div>
  );
}
